import styled from 'styled-components';
import { WRAPPER } from '@/shared/styles/themes';
import { Image as NextImage } from '@/shared/ui/image';
import { Button } from '../form/button';

export const StickyWrapper = styled.div`
  margin-top: 0;
  margin-bottom: 0;
  padding: 12px 0px;
  will-change: transform;
  position: relative;
  background: #27262b;
  position: sticky;
  top: 0;
  z-index: 100;

  @media (max-width: 768px) {
    padding: 12px 12px 12px 4px;
    border-bottom: 1px solid #1b202d;
  }
  @media (max-width: 1024px) and (orientation: landscape) {
    display: flex;
    height: 54px;
    //padding: 12px 12px 12px 4px;
    padding: 12px;
    flex-direction: column;
    justify-content: center;
  }
  @media (max-width: 1024px) and (orientation: portrait) {
    display: flex;
    height: 64px;
    padding: 12px;
    flex-direction: column;
    justify-content: center;
  }

  ${({ $isScrolled }) =>
    $isScrolled &&
    `
  &::after {
    content: '';
    position: fixed;
    bottom: -15px;
    left: 0;
    right: 0;
    background: linear-gradient(180deg, #131315 0%, rgba(19, 19, 21, 0.00) 100%);
    padding: 8px 0;
  }
`}
`;

export const Header = styled.div`
  ${WRAPPER};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (min-width: 769px) and (max-width: 1168px) {
    padding: 0 18px;
    margin: 0;
  }
  @media (max-width: 768px) {
    margin: 0;
    gap: 8px;
  }
`;

export const ImageElement = styled(NextImage)`
  cursor: pointer;
`;

export const AvatarWrapper = styled.div`
  border-radius: 8px;
  display: flex;
  width: ${({ $width }) => `${$width}px`};
  height: ${({ $height }) => `${$height}px`};
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;

  img {
    border-radius: 8px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const HeaderButton = styled(Button)`
  display: flex;
  flex-direction: column;
  flex: auto;
  margin-right: 12px;
  min-width: 40px;
  min-height: 40px;
  ${({ $isEmptyBalance }) =>
    $isEmptyBalance &&
    `
      background: linear-gradient(90deg, #FF9500 0%, #FF5E00 100%);

  &:hover {
  // background: radial-gradient(49.58% 100% at 49.58% 0%, #00DD73 0%, #06C15A 100%);
    }

    
 }


  `}

  @media(max-width:768px) {
    min-width: 40px;
    min-height: 40px;
  }
`;

export const Bonus = styled.div`
  display: flex;
  height: 40px;
  gap: 8px;
  padding: 4px;
  padding-right: 12px;
  margin-right: 12px;

  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: #625a63;
  box-shadow: 0px 3px 3px -2px rgba(18, 22, 32, 0.3);
  ${({ $withoutBonus }) =>
    $withoutBonus &&
    `
    position: relative;
   padding-right: 4px;
  `}
`;

export const GiftButton = styled.div`
  width: 32px;
  height: 32px;
  background-image:
    url('/images/background/gift-bg.svg'), url('/images/background/gift.svg');
  background-repeat: no-repeat, no-repeat;
  background-position: center, center;
  border-radius: 10px;
  background-color: #414d6b;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.2) inset;
  position: relative;
  overflow: hidden;
  z-index: 1;
  cursor: pointer;
  ${({ $withoutBonus }) =>
    $withoutBonus &&
    `
    background-image:url('/images/background/gift-white.svg');
  `}

  ${({ $loading }) =>
    $loading &&
    `
    background-image:url('/images/background/gift-bg-white.svg'), url('/images/icons/element-loader.svg');
  `}
`;
export const GiftProgress = styled.div`
  position: absolute;
  left: -1px;
  top: -1px;
  right: -1px;
  bottom: -1px;
  background-color: transparent;
  animation: gradientAnimation 5s linear infinite;
  z-index: 0;
  border-radius: 10px;

  background-image: ${(props) =>
    `conic-gradient(orange, orange ${props.$percentage}%, transparent 0%)`};
`;

export const GiftProgressWager = styled.div`
  height: 5px;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
  &:before {
    content: '';
    position: absolute;
    display: block;
    height: 100%;
    z-index: 1;
    width: ${({ $progress }) => `${$progress}%`};
    background-image: url('/images/background/bonus-progress.svg');
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 2px;
    animation: progress 5s linear infinite;

    ${({ $isWarning }) =>
      $isWarning &&
      `background-image:url('/images/background/bonus-progress-warning.svg')`}
  }
  &:after {
    content: '';
    position: absolute;
    display: block;
    height: 100%;
    width: 100%;
    background-color: #161639;
    border-radius: 2px;
  }
`;

export const GiftTimer = styled.div`
  border-radius: 8px;
  background: #ffd60a;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.2) inset;
  padding: 2px 4px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  gap: 2px;
  bottom: -12px;
  display: flex;
  z-index: 2;

  ${({ $isWarning }) => $isWarning && `background: #DA4444; color:#EDEFF5`}
`;

export const BonusProgressMobile = styled.div`
  text-align: center;
  background-image: url('/images/background/bonus-progress-mobile.svg');
  background-repeat: no-repeat;
  background-size: cover;
  position: sticky;
  top: 64px;
  z-index: 100;
`;

export const DynamicBonusProgressMobile = styled.div`
  text-align: center;
  background-color: #1b202d;
  position: relative;

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    background-image: ${({ $isWarning }) =>
      $isWarning
        ? `url('/images/background/bonus-progress-mobile-warning.svg')`
        : `url('/images/background/bonus-progress-mobile.svg')`};
    background-repeat: no-repeat;
    background-size: cover;
    ${({ $progress }) => `width:${$progress}%`}
  }
`;

export const ProcessInfo = styled.div`
  display: flex;
  position: absolute;
  left: -8.5px;
  white-space: nowrap;
  bottom: -12px;
  border-radius: 8px;
  z-index: 2;
  background: var(--edeff-5, #edeff5);
  padding: 2px 4px;
  /* Inner 20 */
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.2) inset;
`;
export const FullscreenButton = styled.button`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: #3d3c41;
`;
export const FullScreenImage = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-image: url('/images/icons/jackpot/full-screen.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
